import { mediaItems } from '@/mocks/homeData';

export default function SectionMedia() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">精彩集锦</h2>
          <p className="mt-3 text-sm text-foreground-600">热门剧目名场面混剪与幕后花絮，精彩不容错过</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item) => (
            <div key={item.id} className="bg-background-100 rounded-xl overflow-hidden border border-background-200/70 group cursor-pointer">
              <div className="relative h-40 overflow-hidden">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-2.5 left-2.5 flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-sm"></i>
                  </div>
                  <span className="text-xs text-background-50 font-medium">{item.duration}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-950 font-heading leading-snug line-clamp-2">{item.title}</h3>
                <p className="mt-1.5 text-xs text-foreground-600 line-clamp-2">{item.desc}</p>
                <div className="flex items-center gap-1 mt-3">
                  <i className="ri-eye-line text-xs text-foreground-400"></i>
                  <span className="text-xs text-foreground-400">{item.views} 次播放</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}